<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import DetailView from "@/components/modals/detail-view";
import appConfig from "../../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "@vueform/multiselect/themes/default.css";
import Swal from "sweetalert2";
import { formatDateToWeb, formatCurrency } from "../../../helpers/date-functions";
import { usePermissions } from '@/composables/usePermissions';

export default {
    page: {
        title: "Refund Listing",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role: localStorage.getItem('role'),
            title: "Refund Listing",
            items: [
                {
                    text: "Refund Listing",
                    href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },

            refundList: [],
            refundId: null,
            loadingDetail: false,
            loadingRoles: true,
            ButtonSeen: true,
            date: '',
            cn_sts: '',
            key_search: '',
            program_id: null,
            programList: null,
            dtKey: 0,
        };
    },
  setup() {
        const permissions = usePermissions();
        
        return {
            permissions,
        };
    },
    methods: {
        format_date(value) {
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD');
            }
        },
        formatDateToWeb(value) {
            return formatDateToWeb(value); // Explicitly call the imported function
        },
        formatCurrency(value) {
            return formatCurrency(value); // Explicitly call the imported function
        },

        downloadExcel() {
            this.loadingDetail = true;
            const posting_ = {
                date: this.date,
                cn_sts: this.cn_sts,
                key_search: this.key_search,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
            axios.post(process.env.VUE_APP_AR_API_BASEURL + 'export/refundListingExport', posting_, { responseType: 'blob' })
                .then(response => {
                    if (response) {
                        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        const fileLink = document.createElement('a');

                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', 'Refund Listing.xlsx');
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        this.loadingDetail = false;
                    } else {
                        Swal.fire({
                            title: 'Error',
                            text: 'No records found.',
                            icon: 'error',
                        });
                    }
                })
                .catch(error => {
                    Swal.fire({
                        title: 'Error',
                        text: error.response?.data?.msj || 'Error exporting refunds',
                        icon: 'error',
                    });
                    this.loadingDetail = false;
                });
        },

        getRefundListing() {
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
            axios.get(process.env.VUE_APP_AR_API_BASEURL + 'refunds/refundListing')
                .then(response => {
                    if (response.data) {
                        this.loadingRoles = false;
                        this.refundList = response.data;
                        console.log(this.refundList);
                    } else {
                        Swal.fire({
                            title: 'Error',
                            text: 'No records found.',
                            icon: 'error',
                        });
                    }
                })
                .catch(error => {
                    Swal.fire({
                        title: 'Error',
                        text: error.response?.data?.msj || 'Error fetching refunds',
                        icon: 'error',
                    });
                });
        },

        searchRefundsForm(e) {
            this.loadingRoles = true;
            e.preventDefault();

            const posting_ = {
                date: this.date,
                cn_sts: this.cn_sts,
                key_search: this.key_search,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
            axios.post(process.env.VUE_APP_AR_API_BASEURL + 'refunds/searchRefund', posting_)
                .then(response => {
                    if (response.data) {
                        this.refundList = response.data;
                        this.dtKey += 1;
                        console.log(this.refundList);
                    } else {
                        Swal.fire({
                            title: 'Error',
                            text: 'No records found.',
                            icon: 'error',
                        });
                    }
                    this.loadingRoles = false;
                })
                .catch(error => {
                    Swal.fire({
                        title: 'Error',
                        text: error.response?.data?.msj || 'Error searching refunds',
                        icon: 'error',
                    });
                    this.loadingRoles = false;
                });
        },

        resetForm() {
            this.loadingRoles = true;
            this.date = '';
            this.cn_sts = '';
            this.key_search = '';

            this.getRefundListing();
        },

        importExcel() {
            this.$refs.fileInput.click();
        },

        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                const formData = new FormData();
                formData.append('file', file);
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
                axios.post(process.env.VUE_APP_AR_API_BASEURL + 'refunds/import', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                .then(response => {
                    Swal.fire({
                        title: 'Success',
                        text: response.data.msj || 'Refunds imported successfully.',
                        icon: 'success'
                    });
                    this.getRefundListing();
                })
                .catch(error => {
                    Swal.fire({
                        title: 'Error',
                        text: error.response?.data?.msj || 'Error importing refunds',
                        icon: 'error'
                    });
                });
                // Reset file input
                this.$refs.fileInput.value = '';
            }
        }
    },

    components: {
        Layout,
        PageHeader,
        DataTable,
        flatPickr,
        DetailView,
    },

    mounted() {
        this.getRefundListing();
    },
};

require("@/assets/css/datatable.css");
</script>
<style>
/* .col-xl-8 {
    flex: 0 0 auto;
    width: 82.66667% !important;
} */
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card">
        <div class="card-body">
            <div class="row g-4 align-items-center">
                <div class="col-sm">
                    <div>
                        <h5 class="card-title mb-0">Refund Listing</h5>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body border-bottom-dashed border-bottom">
            <form @submit="searchRefundsForm">
                <div class="row g-3">
                    <div class="col-xl-6">
                        <div class="search-box">
                            <input type="text" class="form-control search"
                                placeholder="Search for Refund ID, Customer Name, Ref. No" v-model="key_search"/>
                            <i class="ri-search-line search-icon"></i>
                        </div>
                    </div>
                    <div class="col-xl-6 pb-3">
                        <div class="row g-2">
                            <div class="col-sm-12">
                                <div class="search-box"><i class="ri-search-line search-icon"></i>
                                    <flat-pickr v-model="date" placeholder="Select Issue Date" :config="rangeDateconfig"
                                        class="form-control"></flat-pickr>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row g-3">
                    <div class="col-xl-6">
                        <div class="search-box">
                            <select class="form-select mb-3" v-model='cn_sts'>
                                <option value="" selected disabled>Search Status</option>
                                <option value="Yes">Resolved</option>
                                <option value="No">Unresolved</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row g-3 justify-content-end">
                    <div class="col-xl-2">
                        <div>
                            <button type="submit" class="btn btn-primary w-100">
                                <i class="ri-equalizer-fill me-2 align-bottom"></i>Search
                            </button>
                        </div>
                    </div>
                    <div class="col-xl-2">
                        <div>
                            <button type="button" @click='resetForm' class="btn btn-danger w-100">
                                <i class="ri-refresh-fill me-2 align-bottom"></i>Reset
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="card-header border-bottom-dashed">
            <div class="row g-3 justify-content-end">
                <div class="col-xl-2">
                    <div v-if="permissions.canCreate?.value">
                        <router-link class="btn btn-success w-100" to="/ar/refund/create" data-key="t-scrollbar"><i class="ri-add-fill align-middle me-1"></i>Create Refund</router-link>
                    </div>
                </div>
                <div class="col-xl-2">
                    <div>
                        <button v-if="permissions.canCreate?.value" @click="importExcel()" class="btn btn-primary w-100"><i class="ri-file-upload-line align-middle me-1"></i> Import Excel</button>
                    </div>
                </div>
                <div class="col-xl-2">
                    <div>
                        <button v-if="permissions.canExport?.value" @click="downloadExcel()" class="btn btn-success w-100"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="card-body">
            <div class="live-preview">
                <div class="row align-items-center g-12">
                    <div class="col-lg-12">
                        <div v-if='loadingRoles'>
                            <div class="spinner-border text-success" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div v-else>
                            <div class="table-responsive">
                                <DataTable :options="{lengthChange: false, searching: false}" :key="dtKey" class="table table-striped table-nowrap mb-0" id="example">
                                    <thead class="table-secondary">
                                        <tr>
                                            <th>#.</th>
                                            <th scope="col">Refund ID</th>
                                            <th scope="col">Payment Date</th>
                                            <th scope="col">Customer Name</th>
                                            <th scope="col">Ref. No</th>
                                            <th scope="col">Amount (RM)</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in refundList" :key="index" class="content">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ item.payment_id }}</td>
                                            <td>{{ format_date(item.payment_date) }}</td>
                                            <td>
                                                <router-link :to="'/customer/customer-details/'+item.customer_id" class="fw-medium link-secondary">
                                                    {{ item.name_as_per_nric }}
                                                </router-link>
                                            </td>
                                            <td>{{ item.invoice_no || '-' }}</td>
                                            <td>{{ formatCurrency(item.amount) }}</td>
                                            <td v-if="item.payment_status == 'refund'"><span class="badge" style="background-color: #0AB39C">Resolved</span></td>
                                            <td v-else><span class="badge" style="background-color: #0AB39C">Resolved</span></td>
                                            <td>
                                                <div class="dropdown">
                                                    <button class="btn btn-soft-secondary btn-sm dropdown" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <i class="ri-more-fill align-middle"></i>
                                                    </button>
                                                    <ul class="dropdown-menu dropdown-menu-end">
                                                        <li>
                                                            <span class="dropdown-item" @click="()=> refundId = index" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg" data-target="#DetailModal">
                                                                <i class="ri-eye-fill align-bottom me-2 text-muted"></i> Refund Details
                                                            </span>
                                                        </li>
                                                        <li class="dropdown-divider"></li>
                                                    </ul>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </DataTable>
                            </div>
                            <DetailView title="Refund Detail">
                                <div class="col-lg-6">
                                    <p class="text-muted mb-0">Customer Name</p>
                                    <h6 class="mb-0">
                                        {{ refundList[refundId]?.name_as_per_nric }}
                                    </h6>
                                </div>
                                <div class="col-lg-6">
                                    <p class="text-muted mb-0">Refund ID</p>
                                    <h6 class="mb-0">
                                        {{ refundList[refundId]?.payment_id }}
                                    </h6>
                                </div>
                                <div class="col-lg-6">
                                    <p class="text-muted mb-0">Payment Date</p>
                                    <h6 class="mb-0">
                                        {{ formatDateToWeb(refundList[refundId]?.payment_date) }}
                                    </h6>
                                </div>
                                <div class="col-lg-6">
                                    <p class="text-muted mb-0">Ref. No</p>
                                    <h6 class="mb-0">
                                        {{ refundList[refundId]?.invoice_no || '-' }}
                                    </h6>
                                </div>
                                <div class="col-lg-6">
                                    <p class="text-muted mb-0">Status</p>
                                    <h6 class="mb-0">
                                        {{ refundList[refundId]?.payment_status === 'resolved' ? 'Resolved' : 'Resolved' }}
                                    </h6>
                                </div>
                                <div class="col-lg-6">
                                    <p class="text-muted mb-0">Total Amount</p>
                                    <h6 class="mb-0">
                                        {{ formatCurrency(refundList[refundId]?.amount) }}
                                    </h6>
                                </div>
                            </DetailView>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <input type="file" ref="fileInput" style="display: none;" @change="handleFileUpload" accept=".xlsx, .xls" />
  </Layout>
</template>